import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// Local design constants (non-spacing sizes)
const LOTTIE_HEIGHT = "18px";
const LOTTIE_WIDTH = "35px";

export const LottieContainer = styled.div(() => ({
    height: LOTTIE_HEIGHT,
    width: LOTTIE_WIDTH,
}));

export const TitleContainer = styled.div(() => ({
    width: "100%",
    display: "flex",
}));

export const CouponCardBanner = styled(Text)(({ theme }) => ({
    margin: `0 ${theme.spacing.large} ${theme.spacing.xLarge}`,
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    borderRadius: theme.cornerRadius.medium,
}));

export const GiftingCouponSectionFooterImage = styled.div<{ aspectRatio?: number }>(({ aspectRatio = 1, theme }) => ({
    width: "100%",
    height: `${aspectRatio}%`,
    marginBottom: theme.spacing.medium,
    marginTop: `calc(${theme.spacing.xSmall} * -1)`,
}));
